import { type Lang, isLang } from "@majourneys/shared";

type SupportedLocale = Lang;

const MOROCCO_BY_LOCALE: Record<SupportedLocale, string> = {
  en: "Morocco",
  fr: "Maroc",
  ar: "المغرب",
  es: "Marruecos",
  it: "Marocco",
  de: "Marokko",
  nl: "Marokko",
};

export function normalizeLocale(locale?: string | null): SupportedLocale {
  const base = locale?.split("-")[0];
  return isLang(base) ? base : "en";
}

export function getMoroccoName(locale?: string | null): string {
  return MOROCCO_BY_LOCALE[normalizeLocale(locale)];
}

export function formatMoroccoLocation(
  cityName: string | null | undefined,
  locale?: string | null,
): string {
  const countryName = getMoroccoName(locale);
  return cityName ? `${cityName}, ${countryName}` : countryName;
}

/**
 * Lower-cases a translated noun for use mid-sentence ("2 adults", "150 MAD /
 * hour"), except in German, where every noun keeps its capital: "2
 * Erwachsene", never "2 erwachsene". Use this instead of a bare
 * `.toLowerCase()` on any `t()` result that names a thing.
 */
export function lowerNoun(text: string, locale?: string | null): string {
  return normalizeLocale(locale) === "de" ? text : text.toLowerCase();
}
